<template>
    <BannerAbstract class="banner-subscription">

        <template #title>
            Subscription Required
        </template>
        <template #message>
            To keep generating 3D models, please choose a subscription plan that fits your needs.
        </template>
        <template #actions>
            <v-btn 
                elevation="0" 
                @click="handleSelect">
                Select Plan
            </v-btn>
        </template>

    </BannerAbstract>
</template>

<script>
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import BannerAbstract from '@/components/common/banner/BannerAbstract.vue'

export default {
    name: 'BannerSurvey',
    components: {
        BannerAbstract
    },
    methods: {
        ...mapActions('router', [
            'openRoute'
        ]),
        handleSelect()
        {
            this.openRoute({ route: ROUTES.ACCOUNT.SUBSCRIPTION })
        }
    }
}
</script>

<style>
.banner-subscription .v-btn {
    color: rgb(var(--v-theme-primary));
}

.banner-subscription .v-btn:hover {
    background-color: rgba(var(--v-theme-error), 0.5);
}
</style>

<style scoped>
.banner-subscription {
    /*background-color: rgba(var(--v-theme-error), 0.2);*/
    background: linear-gradient(180deg, rgba(var(--v-theme-error), 0.5), rgba(var(--v-theme-error), 0.3));
}
</style>